export const subtitles = {
    "1": {
        "startTime": 6.0,
        "endTime": 7.5,
        "transcript": "Ayagniryugtuten?",
        "translation": "Do you want to start?"
    },
    "2": {
        "startTime": 7.6,
        "endTime": 11.5,
        "transcript": "Yaa, ayagnirnariuq-qaa? (Ii-i, yaa.)",
        "translation": "Okay, is it time to start? (Yes, yes.)"
    },
    "3": {
        "startTime": 13.0,
        "endTime": 16.0,
        "transcript": "Atam, can we just introduce ourselves?",
        "translation": "Look, can we just introduce ourselves?"
    },
    "4": {
        "startTime": 16.1,
        "endTime": 23.0,
        "transcript": "Kitak' ukut. Atrit makut.",
        "translation": "Okay, these people. Their names."
    },
    "5": {
        "startTime": 24.0,
        "endTime": 25.5,
        "transcript": "Ann [?].",
        "translation": "Ann [?]."
    },
    "6": {
        "startTime": 26.0,
        "endTime": 28.8,
        "transcript": "From? (From Bethel.)",
        "translation": "From? (From Bethel.)"
    },
    "7": {
        "startTime": 29.0,
        "endTime": 30.0,
        "transcript": "Are you a teacher, or what?",
        "translation": "Are you a teacher, or what?"
    },
    "8": {
        "startTime": 30.1,
        "endTime": 38.0,
        "transcript": "No, I work for [?], and I work for YKHC.",
        "translation": "No, I work for [?], and I work for YKHC."
    },
    "9": {
        "startTime": 39.0,
        "endTime": 41.0,
        "transcript": "[?]",
        "translation": "[?]"
    },
    "10": {
        "startTime": 41.7,
        "endTime": 44.8,
        "transcript": "I'm Lucy Sparck and I work here at KCC.",
        "translation": "I'm Lucy Sparck and I work here at KCC."
    },
    "11": {
        "startTime": 45.9,
        "endTime": 49.0,
        "transcript": "Nalqiggluki. Niicuitukuk [?] atrit.",
        "translation": "Introduce them. We can't hear [?] their names."
    },
    "12": {
        "startTime": 51.0,
        "endTime": 53.0,
        "transcript": "Okay, ingna…",
        "translation": "Okay, over there…"
    },
    "13": {
        "startTime": 54.0,
        "endTime": 55.0,
        "transcript": "…for animals.",
        "translation": "…for animals."
    },
    "14": {
        "startTime": 57.0,
        "endTime": 70.0,
        "transcript": "Makut imumi-am ayagyuallemteńi makunek elluarrluta",
        "translation": "These, back when we were young and [did not watch them] well"
    },
    "15": {
        "startTime": 72.0,
        "endTime": 79.0,
        "transcript": "Elluarrluta tangvangvailemta makut caliaqestaitnek unguvalriit.",
        "translation": "Before we watched the ones working on them who were alive."
    },
    "16": {
        "startTime": 81.8,
        "endTime": 93.0,
        "transcript": "Imkut tau͡gaam-am aulukestemta tua-i alerquuterluki makut yuilqurmiutaat pitullruit.",
        "translation": "Our caretakers, however, had instructions for these animals of the wilderness."
    },
    "17": {
        "startTime": 96.5,
        "endTime": 104.0,
        "transcript": "Tua-i caanguaqerkaunrirluku alerquagurluta pilaraitkut.",
        "translation": "They would instruct us until we would not waste it."
    },
    "18": {
        "startTime": 105.8,
        "endTime": 116.5,
        "transcript": "Ca-llu aturarkaunrilnguq pitsaqutmek pissurpek'naku caanguaruarkauluku.",
        "translation": "They also told us not to delibirately hunt something we would not use, saying that it would get wasted."
    },
    "19": {
        "startTime": 117.0,
        "endTime": 123.0,
        "transcript": "Tau͡gaam qigcikluki pitarkat yuilqurmiutaat pilallruitkut.",
        "translation": "Instead, they would respect animals they hunted in the wilderness."
    },
    "20": {
        "startTime": 126.0,
        "endTime": 137.6,
        "transcript": "Tua-i-am makut qigcikellriit cali wangkutnun tamakut ciuliamta elluarrluki ellaita aulukellruamegteki",
        "translation": "Those who respected them also [passed] those on to us because our ancestors took good care of them"
    },
    "21": {
        "startTime": 141.0,
        "endTime": 150.0,
        "transcript": "Caanguaqevkenaki, uqlautevkenaki-llu pillruitki, alerquutekellruitki wangkutnun.",
        "translation": "Not wasting or polluting with them because they gave us those instructions."
    },
    "22": {
        "startTime": 150.9,
        "endTime": 162.8,
        "transcript": "Tua-i-llu wangkuta kinguani tamakut tua-i wangkutnun taicimalriit qanruyuteput tangaaluki",
        "translation": "And then afterwards, we started seeing those pieces of traditional wisdom that were given to us"
    },
    "23": {
        "startTime": 163.5,
        "endTime": 173.5,
        "transcript": "Una tua-i ner'arkaunrilkumteggu pitsaqutmek tuqulluku pisqevkenaku.",
        "translation": "If we're not going to eat it, not to deliberately kill it."
    },
    "24": {
        "startTime": 174.0,
        "endTime": 182.4,
        "transcript": "Tau͡gaam ner'arkaukumteggu tua-i pisqelluku, uqlautevkenaku-llu pisqelluku.",
        "translation": "But if we're going to eat it, they told us to [hunt it] and not to pollute nature with it."
    },
    "25": {
        "startTime": 184.6,
        "endTime": 194.0,
        "transcript": "Cali tua-i tauna kiagmi puqlanilaami",
        "translation": "Also, because it's warm in the winter"
    },
    "26": {
        "startTime": 194.1,
        "endTime": 200.0,
        "transcript": "Cali tauna tuqutellrukumteggu nani yuilqumi pikumta",
        "translation": "If we kill that [animal] as we're somewhere in the wilderness"
    },
    "27": {
        "startTime": 200.9,
        "endTime": 205.5,
        "transcript": "Tep'ngareskan cailkamun egtesqevkenaku.",
        "translation": "If it starts to smell, they told us not to throw it on the ground."
    },
    "28": {
        "startTime": 206.9,
        "endTime": 214.5,
        "transcript": "Tau͡gaam nuna elaggaarluku, nuna elaggaarluku patuluku-llu.",
        "translation": "Instead, after digging into the land, cover it."
    },
    "29": {
        "startTime": 217.9,
        "endTime": 221.8,
        "transcript": "Tua-i tuaten alerquuterluta.",
        "translation": "We had that instruction."
    },
    "30": {
        "startTime": 224.0,
        "endTime": 225.0,
        "transcript": "Cali…",
        "translation": "Also…"
    },
    "31": {
        "startTime": 227.0,
        "endTime": 230.6,
        "transcript": "One moment. That's going to be translated.",
        "translation": "One moment. That's going to be translated."
    },
    "32": {
        "startTime": 232.3,
        "endTime": 234.9,
        "transcript": "Waqaa? Taklilliuq wall'u-qaa?",
        "translation": "What's the matter? Is it too long or what?"
    },
    "33": {
        "startTime": 235.0,
        "endTime": 239.8,
        "transcript": "Nuu, tauna qanellren taqraarru. (Ii-i.)",
        "translation": "No, finish what you were saying first. (Okay.)"
    },
    "34": {
        "startTime": 242.0,
        "endTime": 248.0,
        "transcript": "Au͡gna icigg' qanrulluki elaggaarluki tau͡gaam tamakut ellisqelluki.",
        "translation": "You know, how they told them only to dig and put those."
    },
    "35": {
        "startTime": 248.1,
        "endTime": 250.0,
        "transcript": "Ii-i, elagluku nuna.",
        "translation": "Yes, dig into the ground."
    },
    "36": {
        "startTime": 252.0,
        "endTime": 259.5,
        "transcript": "Cailkamun egtevkenaku, tau͡gaam elaggaarluku nuna nutaan-llu patuluku tuavet.",
        "translation": "Don't throw it on the ground, but after digging into the land, cover it there."
    },
    "37": {
        "startTime": 260.8,
        "endTime": 273.0,
        "transcript": "Cali-llu nani pikumta neqa camek mat'umek cali tuaten ner'arkaunrilkumteggu assiireskan",
        "translation": "Also, if we have some of this food that has gone bad which we won't eat"
    },
    "38": {
        "startTime": 273.8,
        "endTime": 279.5,
        "transcript": "Tutmallrunrilngurmun ellisqelluku yuum tutmayuilkiinun.",
        "translation": "They said to put it where people have not and will not tread upon."
    },
    "39": {
        "startTime": 282.9,
        "endTime": 293.0,
        "transcript": "Tua-i tamakut tuaten alerquutekellruluki wangkuta tamakunek anglicartemteńek.",
        "translation": "Those were our instructions from those who raised us."
    },
    "40": {
        "startTime": 297.5,
        "endTime": 309.0,
        "transcript": "Cali yuilqumi-am alerquutengqellrulriakut makunek cali nunam qaingani pissulaamteki tua-i makut",
        "translation": "We also had instructions for the wilderness because we hunt these things on the land"
    },
    "41": {
        "startTime": 310.4,
        "endTime": 316.5,
        "transcript": "Cali kapkaanarturluteng ilaput pilaameng wangkuta-llu.",
        "translation": "Because our familes and we used animal traps."
    },
    "42": {
        "startTime": 317.9,
        "endTime": 326.5,
        "transcript": "Tua-i-am cali taum yuum pitaa qigcikluku pisqelluku wangkuta pikenrilamteggu.",
        "translation": "They also told us to respect what that person had caught because it's not ours."
    },
    "43": {
        "startTime": 328.8,
        "endTime": 341.0,
        "transcript": "Cali alerquuterluta tauna ayakataqan-llu wall'u pitarkaq tangerrluku tuqutesqelluku wangkutnun",
        "translation": "We also had instructions that if that one was going to go or if we see an animal to kill it"
    },
    "44": {
        "startTime": 343.5,
        "endTime": 349.5,
        "transcript": "Agarrluku-llu nuniinun tuavet yuan tekiskuniu ayagpailgan",
        "translation": "And hang it there so that when the owner comes to it before leaving"
    },
    "45": {
        "startTime": 350.6,
        "endTime": 357.5,
        "transcript": "Quyaarkauluni yuk tauna tuaten pitaminek kitumun imumun tuaten pillrucianek.",
        "translation": "That person will be thankful that someone had done that to what he had caught."
    },
    "46": {
        "startTime": 359.0,
        "endTime": 365.0,
        "transcript": "Teglegesqevkenaku pikenrilamteggu. Inerquuterluta-am tamatumek.",
        "translation": "They told us not to steal it because it's not ours. We had that admonishment."
    },
    "47": {
        "startTime": 366.8,
        "endTime": 370.0,
        "transcript": "Elitengqertuq-gguq yuum waten piurallra.",
        "translation": "They say a person can learn to do this."
    },
    "48": {
        "startTime": 370.1,
        "endTime": 379.8,
        "transcript": "Yuum piinek pikenrilkeminek tegucullra cali eliterluni pikenrilkeminek tegucugluni.",
        "translation": "One can also learn to talk another person's possession that is not his own."
    },
    "49": {
        "startTime": 380.5,
        "endTime": 384.0,
        "transcript": "Tua-i-am tamakut inerquutnguluteng wangkutnun.",
        "translation": "Those had admonishments for us."
    },
    "50": {
        "startTime": 385.0,
        "endTime": 395.5,
        "transcript": "Tau͡gaam-gguq wangkuta tau͡gaam pitamteńek tuaten atuusqelluta yuum allam pikenrilkiinek tegutevkenata.",
        "translation": "But, they said that we should only use what we caught withought taking another person's."
    },
    "51": {
        "startTime": 398.9,
        "endTime": 406.0,
        "transcript": "Waten tua-i alerquutengqellruukut wangkuta au͡gkunek anglicartemteńek.",
        "translation": "These are the instructions we had from those who raised us back then."
    },
    "52": {
        "startTime": 408.7,
        "endTime": 411.0,
        "transcript": "Waten pitaqerluku pilaku.",
        "translation": "That is all from me."
    },
    "53": {
        "startTime": 412.0,
        "endTime": 413.5,
        "transcript": "Okay…",
        "translation": "Okay…"
    },
    "54": {
        "startTime": 414.5,
        "endTime": 421.0,
        "transcript": "…[ernerit] pitekluki wangkuta alerquutaitellruukut.",
        "translation": "…we didn't have instructions concerning [their days]."
    },
    "55": {
        "startTime": 422.0,
        "endTime": 432.9,
        "transcript": "Tau͡gaam-am niitelartukut imarpiim tungiinek-llu wall'u alqunaq taicingareskan",
        "translation": "But, we hear that from the direction of the ocean or if it suddenly gets foggy"
    },
    "56": {
        "startTime": 434.0,
        "endTime": 444.0,
        "transcript": "Meq, meq taicinga'arrluni pikan wangkuta maani kiaqvarmiuni qanlartukut iliini",
        "translation": "If the water suddenly gets foggy, we upriver people sometimes say"
    },
    "57": {
        "startTime": 445.0,
        "endTime": 451.0,
        "transcript": "“Iliit-gguq-am imarpigmi, imarpigmi pitliniuq.”",
        "translation": "“So, someone has caught something in the ocean.”"
    },
    "58": {
        "startTime": 452.0,
        "endTime": 461.5,
        "transcript": "Taicingareskan tuaten tua-i qanerluta tuaten tuaten tua-i pitniluku, picukluku qanerluta.",
        "translation": "When it gets foggy like that, we say that they caught something, that we think they caught something."
    },
    "59": {
        "startTime": 464.0,
        "endTime": 465.7,
        "transcript": "He said that…",
        "translation": "He said that…"
    },
    "60": {
        "startTime": 465.8,
        "endTime": 466.4,
        "transcript": "…maani.",
        "translation": "…here."
    },
    "61": {
        "startTime": 466.5,
        "endTime": 470.0,
        "transcript": "Maani-q' kiaqvani? (Yaa, nunamiutaat-wa.)",
        "translation": "Upriver here? (Yes, land animals.)"
    },
    "62": {
        "startTime": 471.4,
        "endTime": 474.0,
        "transcript": "Tua-i-wa makut nunamiutaat…",
        "translation": "These land animals…"
    },
    "63": {
        "startTime": 479.0,
        "endTime": 485.0,
        "transcript": "Nallunrilkuvki uss' iliit tamakut nalqiga'arteqerki qaill' nunamiutaat pilauciat.",
        "translation": "Hey, if you know, please explain about some of those, how the land animals [are treated]."
    },
    "64": {
        "startTime": 485.1,
        "endTime": 492.5,
        "transcript": "Nunamiutaat-wa makut au͡gkut ciuliamta aulukellrukait kencikluki.",
        "translation": "Our ancestors back then took care of revered land animals."
    },
    "65": {
        "startTime": 492.6,
        "endTime": 496.0,
        "transcript": "Caluki, tua-i-w' uqlautevkenaki.",
        "translation": "You know, they didn't pollute nature with them."
    },
    "66": {
        "startTime": 496.5,
        "endTime": 500.5,
        "transcript": "Assirluki auluktullruit au͡gkut tangvallma-llu wiinga.",
        "translation": "They and the ones I saw took good care of them."
    },
    "67": {
        "startTime": 501.5,
        "endTime": 514.5,
        "transcript": "Alerquraqluta-llu tamakut enrit natmun paivngalriamun egtesqevkenaki kencikluki.",
        "translation": "They also instructed us not to throw their bones in places with heavy traffic out of reverence."
    },
    "68": {
        "startTime": 515.0,
        "endTime": 522.0,
        "transcript": "Pitait, pitait angutet kencikluki, kenekluki.",
        "translation": "They revered and loved the animals that the men caught."
    },
    "69": {
        "startTime": 522.2,
        "endTime": 527.0,
        "transcript": "Egtevkenaki-llu enqengraitki pitullruit.",
        "translation": "And they didn't[carelessly] throw even their bones away."
    },
    "70": {
        "startTime": 527.1,
        "endTime": 532.5,
        "transcript": "Elauqurluki-llu enrit elakaulluki, tua-i patuqerluki.",
        "translation": "They always dug and covered their bones."
    },
    "71": {
        "startTime": 533.0,
        "endTime": 535.8,
        "transcript": "Tuaten egcet'lallruit imumi ak'a.",
        "translation": "They used to have people dispose of them like that a long time ago."
    },
    "72": {
        "startTime": 535.9,
        "endTime": 540.0,
        "transcript": "Sagtellriartaitellruuq nunam qainga tamarmi.",
        "translation": "There was no mess in all of the land."
    },
    "73": {
        "startTime": 541.0,
        "endTime": 550.3,
        "transcript": "Makunek can-allernek, callernek tua-i makunek Kass'at nerkuaritnek pitangvailgan nunam qainga cataitellruuq.",
        "translation": "Before there were these cans, these various Western garbage materials, there was no [waste] on the land."
    },
    "74": {
        "startTime": 551.3,
        "endTime": 555.0,
        "transcript": "Sagtellriamek kalikallermek-llu tangerrnaitellruuq.",
        "translation": "There was no visible mess or paper materials."
    },
    "75": {
        "startTime": 555.3,
        "endTime": 559.0,
        "transcript": "Assillruuq nunam qainga sagtellriartaunani.",
        "translation": "The land was good with no mess."
    },
    "76": {
        "startTime": 560.6,
        "endTime": 563.9,
        "transcript": "Yuut nunaseng kencikellruat.",
        "translation": "The people revered their land."
    },
    "77": {
        "startTime": 565.0,
        "endTime": 568.9,
        "transcript": "Ukut nunat nunaseng avatetuumaan kencikellruat.",
        "translation": "They revered their land, including the areas around them."
    },
    "78": {
        "startTime": 569.0,
        "endTime": 572.0,
        "transcript": "Wangkuta-llu alerqutullruitkut.",
        "translation": "They also used to instruct us."
    },
    "79": {
        "startTime": 574.8,
        "endTime": 582.0,
        "transcript": "Pingnaqsaraput arnani, iqvaryaraput, tarricaraput, kayangussuryaraput-llu",
        "translation": "The places we women subsist, our berry picking lands, where we tread, and our egg hunting lands"
    },
    "80": {
        "startTime": 582.4,
        "endTime": 588.4,
        "transcript": "Tamakut arulairvikaqamteki uqlarluku unitesqevkenaku.",
        "translation": "They told us that if we stop at those not leave it messy."
    },
    "81": {
        "startTime": 588.5,
        "endTime": 598.0,
        "transcript": "Callret-llu nerkuaput, ilakuaput agurrluk' paivngaluki saggluki uniteqaasqevkenaki",
        "translation": "They also told us never to leave our food scraps, whatever leftovers we had, in open places as messes"
    },
    "82": {
        "startTime": 598.1,
        "endTime": 604.0,
        "transcript": "Tau͡gaam elakauqurluki patuqerturluki pilaasqelluki.",
        "translation": "Instead, always dig and cover them."
    },
    "83": {
        "startTime": 604.5,
        "endTime": 611.6,
        "transcript": "Yuut imkut watuam nalliicetun ayuqellrunritut nunatuumarmeng.",
        "translation": "The people back then, including their land, was not like now."
    },
    "84": {
        "startTime": 612.5,
        "endTime": 618.3,
        "transcript": "Nuna man'a qigcikellruat. Qigcikluku yuullruut.",
        "translation": "They respected this land. They respected it in their lives."
    },
    "85": {
        "startTime": 629.0,
        "endTime": 630.0,
        "transcript": "Well, she said that…",
        "translation": "Well, she said that…"
    },
    "86": {
        "startTime": 633.9,
        "endTime": 640.7,
        "transcript": "Uniciyuunii wiinga iqvatuunga ilumun. (Qanrutelqaaci-qaa?)",
        "translation": "Truly, I do not leave anything when I pick berries. (Did they tell youpl?)"
    },
    "87": {
        "startTime": 641.0,
        "endTime": 645.4,
        "transcript": "Atsanek piaqamta… (Atsanek uniciyuunii iqvatullruunga.)",
        "translation": "When we [pick] berries… (I wouldn't leave berries when I picked them.)"
    },
    "88": {
        "startTime": 645.5,
        "endTime": 651.0,
        "transcript": "Imna-llu iiqupayaaq atauciungraan teguqerluku tua-i qaltamnun ektuaqa.",
        "translation": "I even take a single little seed and put it in my bucket."
    },
    "89": {
        "startTime": 651.5,
        "endTime": 657.5,
        "transcript": "Tua-i-llu unatvalqa tua-i cataunani waten-wa umyuarteq'laama",
        "translation": "And the place I picked berries has nothing because I think like this"
    },
    "90": {
        "startTime": 658.0,
        "endTime": 661.7,
        "transcript": "Umyuartequ'urlua kesianek wiinga pituunga:",
        "translation": "I always think like this:"
    },
    "91": {
        "startTime": 662.0,
        "endTime": 667.0,
        "transcript": "“Agayutem ellilqaa una wani. Wavet nauvkaraa wani.",
        "translation": "“God put this here. He made it grow here."
    },
    "92": {
        "startTime": 667.4,
        "endTime": 671.9,
        "transcript": "“Wiinga picuvvlaglua cekavcilua pingaitua.”",
        "translation": "“I will not [gather] without being thorough and scatttering them.”"
    },
    "93": {
        "startTime": 672.0,
        "endTime": 682.0,
        "transcript": "Maa-i mat'um nalliini ukaqvani mat'umek pingrraanemteńek waten umyuarteqsaurrlua iqvatuunga.",
        "translation": "These days, since we've recently gotten this [religion], this is how I think when I pick berries."
    },
    "94": {
        "startTime": 682.7,
        "endTime": 688.0,
        "transcript": "Iiqupayaaq-llu ataucirraq angenqurrilivkenii ayuqluki teguluki.",
        "translation": "I also take a single berry all the same without saying there are bigger ones."
    },
    "95": {
        "startTime": 688.1,
        "endTime": 693.0,
        "transcript": "Atauciyagaq-llu iliini iiqupayaaq naumalartuq epumi.",
        "translation": "And sometimes, there is a single seed growing on a stem."
    },
    "96": {
        "startTime": 693.5,
        "endTime": 697.8,
        "transcript": "Tauna-llu kiigarrluku uamutkengramku ek'artetuaqa.",
        "translation": "I also peel that off and put it in even though it takes up my time."
    },
    "97": {
        "startTime": 698.0,
        "endTime": 702.5,
        "transcript": "Tua-i piciryaramnek wiinga iqluvkenii qanertua.",
        "translation": "I am honestly talking about my personal custom."
    },
    "98": {
        "startTime": 703.7,
        "endTime": 707.7,
        "transcript": "Okay, she's answering it, this, from…",
        "translation": "Okay, she's answering it, this, from…"
    },
    "99": {
        "startTime": 707.8,
        "endTime": 712.0,
        "transcript": "Tamatum nalliini yaqulget amllepiatullrulriit.",
        "translation": "At that time, there were a great many birds."
    },
    "100": {
        "startTime": 714.0,
        "endTime": 717.0,
        "transcript": "Qangqiiret-llu cali amllepiatullruluteng.",
        "translation": "There were also a great many ptarmigans."
    },
    "101": {
        "startTime": 720.5,
        "endTime": 728.5,
        "transcript": "Tua-i makunek alerquutellegnek anguyagtem pistainek alairpailgata",
        "translation": "Before there were these governement workers with laws"
    },
    "102": {
        "startTime": 729.5,
        "endTime": 734.5,
        "transcript": "Yuut tua-i up'nerkami tau͡gaam pissutullrulriit yaqulegnek qangqiirnek-llu.",
        "translation": "People used to hunt in the spring for birds and ptarmigans."
    },
    "103": {
        "startTime": 735.5,
        "endTime": 745.5,
        "transcript": "Tau͡gaam tamakut pitateng, tua-i-wa taryuq man'a tekitellruami tamaa nallemteńi wangkuta",
        "translation": "But what they caught, because salt came early in our time"
    },
    "104": {
        "startTime": 746.3,
        "endTime": 750.5,
        "transcript": "Tamakut tua-i yaqulget sulunatullruaput assiirpailgata.",
        "translation": "We would preserve those birds with salt before they spoiled."
    },
    "105": {
        "startTime": 751.8,
        "endTime": 759.0,
        "transcript": "Makut-llu qangqiiret agarrluki kinercirluki kemgit.",
        "translation": "They would also hang ptarmigan meat to dry."
    },
    "106": {
        "startTime": 759.2,
        "endTime": 762.5,
        "transcript": "Tua-i tuatnatullruaput tamakut.",
        "translation": "We [preserved] those like that."
    },
    "107": {
        "startTime": 763.0,
        "endTime": 772.5,
        "transcript": "Cali nuqlitetullruameng tamaani iliini makut kuvyat alairpailgata",
        "translation": "Also, because they would sometimes have shortages back then before these [Western] nets appeared"
    },
    "108": {
        "startTime": 773.5,
        "endTime": 781.4,
        "transcript": "Arutulinek, arutulinek kuvyangqellruamta tamaani allrakuaqan cimiryarauluteng",
        "translation": "Because we had nets and deteriorated back then that needed to be replaced every year"
    },
    "109": {
        "startTime": 781.5,
        "endTime": 788.3,
        "transcript": "Ilii pisciigataqluni, unangesciiganani neqmek amllermek.",
        "translation": "Sometimes, it couldn't catch a lot of fish."
    },
    "110": {
        "startTime": 788.9,
        "endTime": 797.0,
        "transcript": "Tua-i tamaa-i tamakut piaqamteki, nutegnek-llu anglanillrunrilamta",
        "translation": "When we [hunted] those, because we didn't have an abundant supply of guns"
    },
    "111": {
        "startTime": 797.1,
        "endTime": 806.5,
        "transcript": "Qangqiirnek ciumek pilaamta negartura'arluki tau͡gaam pelacinaggarnek pissutullruluki qangqiiret.",
        "translation": "Because we hunted ptarmigans first, we would trap ptarmigans with snares made from twine."
    },
    "112": {
        "startTime": 808.0,
        "endTime": 815.0,
        "transcript": "Tua-i tuaten pitullruluta amllellruameng tamatum nalliini",
        "translation": "We used to do that because there were a lot back then"
    },
    "113": {
        "startTime": 815.8,
        "endTime": 823.0,
        "transcript": "Makunek igvarivailgata makut qatellriit akmani caliamegteggun.",
        "translation": "Before these Caucasians these things with their work out of state."
    },
    "114": {
        "startTime": 825.0,
        "endTime": 831.5,
        "transcript": "Makunek-llu melqunek imalegnek paltuugugarnek Alaska-q patuvailgan",
        "translation": "And before Alaska was covered with these numerous coats that are filled with fur"
    },
    "115": {
        "startTime": 832.4,
        "endTime": 837.0,
        "transcript": "Yaqulget melqurritnek imarluteng amlletullruameng tamaani.",
        "translation": "They were filled with bird feathers because there was a lot back then."
    },
    "116": {
        "startTime": 837.7,
        "endTime": 845.0,
        "transcript": "Tua-i tamakut up'nerkami sulunatullruaput yaqulget ilait kiagmi ner'arkauluki.",
        "translation": "We used to preserve some of those birds in salt during the spring to eat them over the summer."
    },
    "117": {
        "startTime": 846.0,
        "endTime": 853.4,
        "transcript": "Cali-llu pilaraitkut imkut, waten kayungussutuukut up'nerkami.",
        "translation": "They also told us, [you know] we gather eggs in the spring like this."
    },
    "118": {
        "startTime": 854.5,
        "endTime": 858.5,
        "transcript": "Tua-i-llu ukut wani murilkelaamegteki kayangut",
        "translation": "Because they observed these eggs"
    },
    "119": {
        "startTime": 860.4,
        "endTime": 865.4,
        "transcript": "Kayangut yung'artaqata tua-i tuani taqevkalaraitkut.",
        "translation": "They would have us stop when the fetuses developed in the eggs."
    },
    "120": {
        "startTime": 865.5,
        "endTime": 872.5,
        "transcript": "Kayangut tegunqigtesqevkenaki yungniluki, yaqulgurtarkaurrniluki.",
        "translation": "They told us not to take eggs again because their fetuses had developed and would become birds."
    },
    "121": {
        "startTime": 873.0,
        "endTime": 877.0,
        "transcript": "Tua-i, tua-i tuaten cali inerquuterluta tamakunek.",
        "translation": "We also had admonishments like that for those."
    },
    "122": {
        "startTime": 879.4,
        "endTime": 886.0,
        "transcript": "Cali tua-i qanrutaqluta imkut anglicartemta waten",
        "translation": "Those who raised us would also tell us this"
    },
    "123": {
        "startTime": 887.7,
        "endTime": 905.9,
        "transcript": "Cali tamakut unangkengaput tuaten cali uqlauskumteki waten qanerluta, qanrulluta:",
        "translation": "If we also polluted nature with those things we gathered, they would tell us this:"
    },
    "124": {
        "startTime": 906.8,
        "endTime": 912.9,
        "transcript": "Aulukestemta-gguq uqlaupakaqumteki wangkutnek au͡g'arciqai tamakut.",
        "translation": "If we keep polluting nature with them, our caretaker will remove those."
    },
    "125": {
        "startTime": 914.8,
        "endTime": 918.8,
        "transcript": "Tua-i tuaten qanruyuterluta.",
        "translation": "We had that traditional wisdom."
    },
    "126": {
        "startTime": 920.5,
        "endTime": 923.9,
        "transcript": "Uqlauskumteki-gguq wangkutnun cikiutekenrirciqai.",
        "translation": "They said that if we pollute nature with them, he will not give them to us anymore."
    },
    "127": {
        "startTime": 924.0,
        "endTime": 933.5,
        "transcript": "Yuk-gguq tua-i piyurraarluni unangyurraarluni unangesciigalituluni uqlaupakaquniki pitani.",
        "translation": "They say that after that person is a good hunter and catches a lot, he can no longer catch anything because he pollutes nature with what he catches."
    },
    "128": {
        "startTime": 934.4,
        "endTime": 939.5,
        "transcript": "Okay, he mentioned [Forest] and asked him a question.",
        "translation": "Okay, he mentioned [Forest] and asked him a question."
    },
    "129": {
        "startTime": 942.0,
        "endTime": 944.8,
        "transcript": "Qaill' qigcik'lallrusiki tamakut?",
        "translation": "How did you show respect to those?"
    },
    "130": {
        "startTime": 946.5,
        "endTime": 953.5,
        "transcript": "Qaillun-llu… cure them?",
        "translation": "And how...cure them?"
    },
    "131": {
        "startTime": 957.0,
        "endTime": 959.0,
        "transcript": "Cure them? How did they cure them?",
        "translation": "Cure them? How did they cure them?"
    },
    "132": {
        "startTime": 959.5,
        "endTime": 962.0,
        "transcript": "You make them last through the winter or…",
        "translation": "You make them last through the winter or…"
    },
    "133": {
        "startTime": 964.8,
        "endTime": 966.5,
        "transcript": "Would you eat them all winter long?",
        "translation": "Would you eat them all winter long?"
    },
    "134": {
        "startTime": 968.0,
        "endTime": 973.4,
        "transcript": "Qaill' qemaggluki caluki, icigg' pegtevkenaki?",
        "translation": "How did you preserve them, you know, without discarding them?"
    },
    "135": {
        "startTime": 973.5,
        "endTime": 980.0,
        "transcript": "Qaill' aulukluki? Ii-i. (Ii-i. Auluksuarneq-qaa?)",
        "translation": "How did you take care of them? Yes. (I see. How do take care of them?)"
    },
    "136": {
        "startTime": 981.0,
        "endTime": 985.5,
        "transcript": "Uksuarmi-wa yaqulget waten piyaraat-wa",
        "translation": "The habit for birds in the fall"
    },
    "137": {
        "startTime": 987.0,
        "endTime": 991.0,
        "transcript": "Kuimanga'artaqata murilkelaamegteki imkut yuut",
        "translation": "When they start swimming, because the people back then observed them"
    },
    "138": {
        "startTime": 992.5,
        "endTime": 1002.0,
        "transcript": "Mik'aqameng-gguq yaqulget makut piyagaat neqngunritut miksiyaagluteng angliriqerpailegmeng.",
        "translation": "They said that when bird chicks are small, they are not food because they're too small before they grow."
    },
    "139": {
        "startTime": 1002.5,
        "endTime": 1018.0,
        "transcript": "Tau͡gaam tua-i nutaan angliriqercameng yaqiuqlagangartellratni tamaani tua-i nutaan neqngurcilarait.",
        "translation": "Only when they are grown and start flapping their wings, they treat them as food only then."
    },
    "140": {
        "startTime": 1019.8,
        "endTime": 1027.8,
        "transcript": "Nutaan tamaani piyugngaluki pikunegteki yuum amlleq-llu tamakunek piyuilami",
        "translation": "A person can then [hunt] them if he wants to, and because he wouldn't catch a lot"
    },
    "141": {
        "startTime": 1028.0,
        "endTime": 1034.0,
        "transcript": "Caqapigtellriit tau͡gaam yuut ayagayugngalriit tamakunek",
        "translation": "Only once in a great while, people who are able to travel [hunt] those."
    },
    "142": {
        "startTime": 1034.5,
        "endTime": 1044.5,
        "transcript": "Yuilqumun ayagalaameng mat'umi September-aami atsanun pingaqameng, August-aam-llu maani nangellrani",
        "translation": "Because they travel to the wilderness in September when the berries are [ready], and at the end of August"
    },
    "143": {
        "startTime": 1045.0,
        "endTime": 1050.0,
        "transcript": "Tamaa-i tamaani anglirilartut piyagaat.",
        "translation": "Those chicks grow at that time."
    },
    "144": {
        "startTime": 1051.0,
        "endTime": 1062.5,
        "transcript": "Tua-i urenkutmek tau͡gaam pissu'urqamegteki assiriaqata piyagaat tengvailgata",
        "translation": "But when people hunt during the time of opportunity when the chicks are good before they can fly"
    },
    "145": {
        "startTime": 1063.8,
        "endTime": 1072.5,
        "transcript": "Tuaten nutaan unangkengaqameng au͡gkut tua-i sulunarluki pituit assiirutarkauvkenaki.",
        "translation": "When the people back then caught some, they would preserve them in salt to prevent spoiling."
    },
    "146": {
        "startTime": 1073.5,
        "endTime": 1083.5,
        "transcript": "Piilkuneng assiirutarkaugaqata nutaan ilameggnun cikiutekluki tuaten assiirupailgata.",
        "translation": "If they don't have any and they woould spoil, they would give them to their families before they spoil like that."
    },
    "147": {
        "startTime": 1087.0,
        "endTime": 1099.0,
        "transcript": "He's saying that when birds are, when little birds are small, he said they're not much of food for them.",
        "translation": "He's saying that when birds are, when little birds are small, he said they're not much of food for them."
    },
    "148": {
        "startTime": 1101.0,
        "endTime": 1105.5,
        "transcript": "But only when they get bigger, people then go after them.",
        "translation": "But only when they get bigger, people then go after them."
    },
    "149": {
        "startTime": 1106.0,
        "endTime": 1111.4,
        "transcript": "And he's saying that, you know, from being around here, he said not everybody went after them.",
        "translation": "And he's saying that, you know, from being around here, he said not everybody went after them."
    },
    "150": {
        "startTime": 1111.5,
        "endTime": 1117.7,
        "transcript": "But those who did, went after them and then salted them again. And if you…",
        "translation": "But those who did, went after them and then salted them again. And if you…"
    },
    "151": {
        "startTime": 1118.5,
        "endTime": 1123.0,
        "transcript": "…-gguq-qaa tamakut, wall'u-qaa tamaa nertulqait?",
        "translation": "…she asked if [they stored] those, or did they eat them right away?"
    },
    "152": {
        "startTime": 1124.0,
        "endTime": 1134.0,
        "transcript": "Tamaani ilaita kayangut kayangussu'urqameng tuaten cipnelegmek pissu'urqameng",
        "translation": "Back then, when some gathered eggs, when they gathered more than they needed"
    },
    "153": {
        "startTime": 1136.8,
        "endTime": 1144.0,
        "transcript": "Qassaita elaucuitait, cayuitait-ll' qemagcuitat tau͡gaam kenirraarluki.",
        "translation": "They don't dig them into the ground raw, or store them, only after cooking them."
    },
    "154": {
        "startTime": 1145.0,
        "endTime": 1151.5,
        "transcript": "Kenirraarluki nutaan tuaten assiirutarkaunrirluteng taq'lartut.",
        "translation": "They're only done and won't spoil after cooking like that."
    },
    "155": {
        "startTime": 1152.4,
        "endTime": 1155.0,
        "transcript": "Kenirraarluki tau͡gaam nutaan qemaggluki.",
        "translation": "They only stored them after cooking them."
    },
    "156": {
        "startTime": 1155.9,
        "endTime": 1157.8,
        "transcript": "Natmun? Camun?",
        "translation": "To where? To what?"
    },
    "157": {
        "startTime": 1157.9,
        "endTime": 1162.5,
        "transcript": "Tua-i-wa natmun, natmun pilartatki?",
        "translation": "I'm not sure where they stored them."
    },
    "158": {
        "startTime": 1163.0,
        "endTime": 1170.5,
        "transcript": "Ilait cikuvkarluki, tua-i cikumaluteng keniumaluteng quyuita tua-i qemaggluki.",
        "translation": "Some froze them, cooked and froze them, then stored them all together."
    },
    "159": {
        "startTime": 1170.6,
        "endTime": 1180.5,
        "transcript": "Ilaita-llu tamaa ciuqvani uquutnek pingqelallruameng angtuanek caqussayugnek",
        "translation": "And because they had seal oil containers a long time ago, big seal pokes"
    },
    "160": {
        "startTime": 1180.6,
        "endTime": 1186.5,
        "transcript": "Tamaa-i tamaavet ilait camun umyuaqutaqamegteki qemaggluki",
        "translation": "They would store some of them in those to prepare for uncertainty"
    },
    "161": {
        "startTime": 1187.0,
        "endTime": 1191.6,
        "transcript": "Kenirraarluki tau͡gaam uqumun pulalluki.",
        "translation": "Only submerging them in seal oil after cooking them."
    },
    "162": {
        "startTime": 1192.5,
        "endTime": 1200.0,
        "transcript": "Tua-i nutaan pinariata tua-i nutaan kautuarluki anlluki tamakut kayangut.",
        "translation": "When it was time, they would reach in and take those eggs out."
    },
    "163": {
        "startTime": 1201.0,
        "endTime": 1204.5,
        "transcript": "Okay, he's saying that if people take…",
        "translation": "Okay, he's saying that if people take…"
    },
    "164": {
        "startTime": 1206.6,
        "endTime": 1208.0,
        "transcript": "Caugat ukut?",
        "translation": "What do these people [work as]?"
    },
    "165": {
        "startTime": 1212.0,
        "endTime": 1217.0,
        "transcript": "Ukut Fish and Wildlife-ami work-atuuq, calituuq. (Ii-i.)",
        "translation": "[S]he works, caliluni, at Fish and Wildlife. (I see.)"
    },
    "166": {
        "startTime": 1219.0,
        "endTime": 1222.0,
        "transcript": "YKHC-mi-llu una. (Ii-i.)",
        "translation": "And this one at YKHC. (I see.)"
    },
    "167": {
        "startTime": 1223.6,
        "endTime": 1235.0,
        "transcript": "Au͡gkuneng aptarpenga qaillun seal-at pitaqaqamteki qaillun piluki [pillerniaratneng].",
        "translation": "You asked me about who [we store] these seals when we catch them."
    },
    "168": {
        "startTime": 1235.1,
        "endTime": 1238.0,
        "transcript": "Yaa, mat'um kumlivigtangvailgan. (Yaa.)",
        "translation": "Yes, before there were freezers. (Okay.)"
    },
    "169": {
        "startTime": 1238.5,
        "endTime": 1244.0,
        "transcript": "Kumlivigtangvailgan pillrat ukut nallunricugait. (Ii-i.)",
        "translation": "They want to know how they [stored food] before freezers. (I see.)"
    },
    "170": {
        "startTime": 1244.1,
        "endTime": 1245.5,
        "transcript": "Nuu.",
        "translation": "No."
    },
    "171": {
        "startTime": 1245.6,
        "endTime": 1252.8,
        "transcript": "Au͡gkunek anerneritnek pitaqaqamegteki unegkumiut seal-at (Au͡g'um anernerit pitekluki.)",
        "translation": "Their spirits when they catch seals down from the ocean (For their spirits.)"
    },
    "172": {
        "startTime": 1253.0,
        "endTime": 1257.0,
        "transcript": "Qaill' anernerit piluki pilartatki?",
        "translation": "How do they [show respect] to their spirits?"
    },
    "173": {
        "startTime": 1259.0,
        "endTime": 1266.4,
        "transcript": "Qaillun anernera taum pitaqekuniu tuqukuni qaillun piluku piciqa?",
        "translation": "What will happen to the spirit of that [seal] when it's caught and dead?"
    },
    "174": {
        "startTime": 1266.5,
        "endTime": 1271.5,
        "transcript": "Nuu, elpeci-ggem qaill' pitullrunillrungataci mercilluki qaill'…",
        "translation": "No, didn't you say that you did something to them, giving them water to drink…"
    },
    "175": {
        "startTime": 1272.5,
        "endTime": 1276.5,
        "transcript": "Oh, tamakut. Oh, yaa.",
        "translation": "Oh, those. Oh, yes."
    },
    "176": {
        "startTime": 1277.0,
        "endTime": 1284.0,
        "transcript": "Pitaqaqamegteki tamaani nayirraungraan qang'a-llu maklaungraan",
        "translation": "Back when they caught them, even if it was a small ringed seal or even a bearded seal"
    },
    "177": {
        "startTime": 1285.3,
        "endTime": 1291.5,
        "transcript": "Waten up'nerkami pitaqaqamegteki, tagutaqamegteki, enmun itrutaqamegteki",
        "translation": "When they caught them in the spring, brought them to land, brought them into their homes."
    },
    "178": {
        "startTime": 1292.5,
        "endTime": 1298.0,
        "transcript": "Nayirraungraan qang'a-llu maklak pitaqaqamegteggu",
        "translation": "When they catch even a small ringed or even a bearded seal"
    },
    "179": {
        "startTime": 1299.0,
        "endTime": 1304.9,
        "transcript": "Maaggun tau͡ga unataikun ca pitekluku tamana [pillerniaraa]",
        "translation": "For some reason, [s]he would [do this] here with his hands"
    },
    "180": {
        "startTime": 1305.0,
        "endTime": 1315.5,
        "transcript": "Mermeng ugg'un unataikun kuvqaquuqerraarluku aitarrluku-gga kemgilengraan",
        "translation": "After pouring water on his hands, open its mouth even if it's skinny"
    },
    "181": {
        "startTime": 1316.8,
        "endTime": 1319.8,
        "transcript": "Kemgilengraan qanranun tauna ilakuarteng kuvluku.",
        "translation": "Even if it's skinny, pour that leftover [water] in its mouth."
    },
    "182": {
        "startTime": 1321.0,
        "endTime": 1324.5,
        "transcript": "Tuqumangraan? (Ii-i, tuqumangraan.)",
        "translation": "Even though its dead? (Yes, even though it's dead.)"
    },
    "183": {
        "startTime": 1324.6,
        "endTime": 1327.5,
        "transcript": "Ullingqangraan enem iluani maklak tauna.",
        "translation": "Even if that bearded seal is butchered inside that house."
    },
    "184": {
        "startTime": 1328.8,
        "endTime": 1335.4,
        "transcript": "Tau͡ga-llu tamat-llam man'a maklagmeng pit'eqerraakacagalria civuqliuluku",
        "translation": "And then, the first thing when a boy had his very first catch of everything, even a bearded seal"
    },
    "185": {
        "startTime": 1336.5,
        "endTime": 1342.8,
        "transcript": "Nutaan wanigg' pissuryaurqaaralria nutaan maklagmeng pitaqeqarraaraqaku",
        "translation": "When one who went on his first hunting trip caught his first bearded seal"
    },
    "186": {
        "startTime": 1343.3,
        "endTime": 1347.0,
        "transcript": "Tau͡gatnarraarluku cali unataikun ugg'un kuv'rraarluku…",
        "translation": "After doing that, pouring [water] with his hands here…"
    }
};